export default function Flex({
	as: Component = "div",
	width = "100%",
	flex,
	justifyContent = "space-between",
	alignItems = "center",
	flexDirection = "row",
	gap = "normal",
	style,
	children,
	wrap,
	scroll,
	innerRef,
	...props
}) {
	return (
		<Component
			ref={innerRef}
			style={{
				width,
				display: "flex",
				justifyContent,
				alignItems,
				gap,
				flex,
				flexDirection,
				flexWrap: wrap ? "wrap" : "nowrap",
				overflow: scroll ? "auto" : "initial",
				scrollbarWidth: "none",
				...style,
			}}
			{...props}
		>
			{children}
		</Component>
	);
}
